import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const VouchersPage = lazyWithRetry(() =>
  import("@/features/vouchers/pages/VouchersPage").then((m) => ({ default: m.VouchersPage })),
);

export const VOUCHERS_PATH = "/bons";

const vouchersRoutes: RouteConfig[] = [
  {
    path: VOUCHERS_PATH,
    element: <VouchersPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default vouchersRoutes;
